export default __webpack_public_path__ + "images/SBK.34e7e1a.png";